import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, renderSlot as _renderSlot, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-secondary-light px-7" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "mr-1 font-bold" }
const _hoisted_4 = { class: "text-xs py-1.5" }

import { computed, inject, ref, Ref } from 'vue';
import SlideUpDown from 'vue3-slide-up-down';
import { v4 } from 'uuid';


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
  },
  third: {
    type: String,
  },
  status: {
    type: String,
  },
  voided: {
    type: Boolean,
  },
},
  setup(__props, { expose }) {

const uuid = ref(v4());

const open = inject<Ref<string>>('open');

const visible = computed(() => uuid.value === open?.value);

function toggle() {
  if (open) {
    if (open.value === uuid.value) {
      open.value = '';
    } else {
      open.value = uuid.value;
    }
  }
}



expose({ sectionUuid: uuid.value });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex justify-between py-3 cursor-pointer select-none", { 'line-through': __props.voided }]),
        onClick: toggle
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
          _createElementVNode("div", null, _toDisplayString(__props.subtitle), 1),
          _createElementVNode("div", null, _toDisplayString(__props.third), 1)
        ]),
        _createElementVNode("div", null, _toDisplayString(__props.status), 1)
      ], 2),
      (_ctx.$slots.info)
        ? (_openBlock(), _createBlock(_unref(SlideUpDown), {
            key: 0,
            modelValue: _unref(visible),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _renderSlot(_ctx.$slots, "info")
              ])
            ]),
            _: 3
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(SlideUpDown), {
      modelValue: _unref(visible),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null))
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["modelValue"])
  ]))
}
}

})